import { FetchedWasteTypes } from "@/Utils/api/sanity/types";
import { sortByOrderRank } from "@/Utils/wasteStreams";
import { Option } from "@/components/pageCards/filterSort/types";
import { WasteTypeConfig } from "@/pages/configuration/useConfigService";

import uniqWith from "lodash/uniqWith";
import { WasteType } from "server/dwhApi/common.js";
import { GetCustomersResponse } from "server/dwhApi/customers/models.js";

export const getWasteTypesOptions = (
  currentPeriod: GetCustomersResponse | undefined,
  wasteTypeNames: FetchedWasteTypes | null,
  wasteTypeConfig: WasteTypeConfig[],
): Option[] => {
  const datawarehouseWasteTypes =
    uniqWith(
      currentPeriod?.customers.flatMap((t) => t.wasteTypes),
      (a: WasteType, b: WasteType) => a.code === b.code,
    ) || [];

  const getWasteTypeName = (wasteTypeId: string) =>
    wasteTypeConfig.find((wtc) => wtc.wasteTypeCode === wasteTypeId)?.name ||
    wasteTypeNames?.find((wtn) => wtn.id === wasteTypeId)?.name ||
    "";

  const availableWasteTypes = datawarehouseWasteTypes.filter(
    ({ code }) => !!getWasteTypeName(code),
  );
  const sortedWasteTypes = sortByOrderRank(
    availableWasteTypes,
    wasteTypeNames || [],
    "code",
  );
  const options = sortedWasteTypes.map(({ code }) => ({
    option: getWasteTypeName(code),
    value: code,
    translate: false,
  }));

  const allWasteTypes = {
    option: "filterLabels:allWasteTypes",
    value: "all",
    translate: true,
  };

  return [allWasteTypes, ...options];
};
